<template>
    <div class="campaign-adset-location__input">
        <div class="pull-right select-input-controls">
            <a href="#" @click.prevent="selectAll">Select All</a>
            <span class="text-muted">|</span>
            <a href="#" @click.prevent="reset">Reset</a>
            <span class="text-muted">|</span>
            <span style="font-size: 13px; color: #777777;">{{ statesSelected.length }} of {{ statesList.length }} selected</span>
        </div>

        <div class="clearfix"></div>

        <div class="campaign-adset-location__input">
            <multiselect
                v-model="statesSelected"
                :options="searchResults"
                :multiple="true"
                :placeholder="placeholder"
                :searchable="true"
                @search-change="search"
                :internalSearch="false"
                :custom-label="includeStateAbbreviationInLabel"
                label="label"
                :close-on-select="false"
                :hide-selected="true"
                :show-labels="false"
                @select="fireSelectEvent"
                track-by="id"
                >
            </multiselect>
        </div>

        <div class="clearfix"></div>
    </div>
</template>

<style>
.select-input-controls {
    margin-top: -15px;
}
</style>

<script>
    import Multiselect from 'vue-multiselect'

    export default {
        props: {
            placeholder: {
                type: String,
                required: true
            },
            value: {
                type: Array,
                default: []
            },
            statesList: {
                type: Array
            }
        },

        data() {
            return {
                statesSelected: this.value,
                searchResults: this.statesList
            }
        },

        mounted() {
            this.search('');
        },

        watch: {
            value(value) {
                this.statesSelected = value;
                this.search('');
            },

            statesSelected(value) {
                this.$emit('input', value);
            }
        },

        methods: {
            fireSelectEvent(value) {
                this.$emit('select', value);
            },

            search(query) {
                this.searchResults = _(this.statesList)
                    // Filter out already selected from results.
                    .filter(state => {
                        return ! _(this.statesSelected).find({id: state.id});
                    })
                    // Filter only results that match the search query.
                    .filter(state => {
                        return state.id.toLowerCase().match(new RegExp(query.toLowerCase()))
                            || state.label.toLowerCase().match(new RegExp(query.toLowerCase()));
                    })
                    .value();
            },

            includeStateAbbreviationInLabel(state) {
                const stateAbbreviation =  state.id;
                const stateFullName =  state.label;

                return stateAbbreviation + ' - ' + stateFullName;
            },

            selectAll() {
                this.statesSelected = this.statesList;
            },

            reset() {
                this.statesSelected = [];
            }
        },

        components: {
            Multiselect
        }
    }
</script>
